import { render, staticRenderFns } from "./Bookmarklet.vue?vue&type=template&id=738974d0&scoped=true"
import script from "./Bookmarklet.vue?vue&type=script&lang=js"
export * from "./Bookmarklet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738974d0",
  null
  
)

export default component.exports